import ApiService from '../../../../shared/services/api-service';
import commonActions from '../../../../shared/store/common/action-creators';
import addressesActionsCreators from '../../addresses/action-creators';
import myProfileActionCreators from './my-profile';
import notificationsActionsCreator from '../../notifications/action-creators';

const myProfileAddressesActionsCreators = {
  updateMyProfileAddresses(formData) {
    const patchData = {
      data: formData.addresses,
      patched: 'addresses',
    };
    return async (dispatch) => {
      dispatch(this.setIsLoading('updateMyProfileAddresses'));
      const data = await ApiService.patch('/api/v1/my-profile', patchData)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('updateMyProfileAddresses'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.updateMyProfileAddressesSuccess(data));
      }
    };
  },
  updateMyProfileAddressesSuccess(updated) {
    return (dispatch) => {
      dispatch(myProfileActionCreators.replaceMyProfile(updated.data));
      // This action handles success for both add and edit, so make sure we dispatch
      //   to reset both related state keys
      dispatch(addressesActionsCreators.resetAddressState());
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Addresses updated'))
    };
  },
};

export default myProfileAddressesActionsCreators;
